import { render, staticRenderFns } from "./JSelectGrpComponentModal.vue?vue&type=template&id=25b526c2&scoped=true&"
import script from "./JSelectGrpComponentModal.vue?vue&type=script&lang=js&"
export * from "./JSelectGrpComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b526c2",
  null
  
)

export default component.exports